import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { fullStoryIntegration } from '@sentry/fullstory';
import { PlUtil } from '@app/common/pl-util';
import * as FullStory from '@fullstory/browser';
import { AppModule } from './app/app.module';

const fullStoryKey = PlUtil.getEnvVar('fullstory_key', 'pl-fullstory-key');
if (fullStoryKey) {
  FullStory.init({ orgId: fullStoryKey });
}
const sentryKey = PlUtil.getEnvVar('sentry_dsn', 'pl-sentry-key');
if (sentryKey) {
  Sentry.init({
    dsn: sentryKey,
    integrations: [
      fullStoryIntegration('presencelearning', { client: FullStory }),
    ],
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => {
    // eslint-disable-next-line no-console
    console.error(err);
  });
